<script setup>

import {ref} from "vue";
import {useForm} from "@inertiajs/vue3";
import BaseInputLabeled from "@/Components/UI/inputs/BaseInputLabeled.vue";
import BaseSettingsForm from "@/Components/UI/forms/DefaultSettingsForm.vue";

defineProps({
    readOnly: Boolean,
})

const defaults = {
    name: "",
    payment_account: "",
    correspondent_account: "",
    bik: "",
}
const form = useForm(defaults);
let currentId = ref(null);
const organizationId = ref(null);

const fillData = (orgId, account, force) => {
    organizationId.value = orgId;
    if (account && !('id' in account)) {
        if (currentId.value === null && !force) {
            return
        }
        currentId.value = null;
    } else {
        if (currentId.value === account.id && !force) {
            return
        }
        currentId.value = account.id;
    }
    let def = Object.assign(JSON.parse(JSON.stringify(defaults)), account);
    if (!def.name) {
        def.name = '';
    }
    // noinspection JSCheckFunctionSignatures
    form.defaults(def)
    form.reset();
    form.clearErrors();
}

defineExpose({fillData});

const emit = defineEmits(['submit'])
const submit = () => {
    const opts = {
        only: ['errors', 'organizations', 'flash', 'result'],
        preserveScroll: true,
        onSuccess: (res) => {
            emit('submit', res.props.flash.result);
            fillData(organizationId.value, {}, true);
        },
    };
    if (currentId.value === null) {
        form.post(route('organizations.accounts.store', {
            organization: organizationId.value
        }), opts);
    } else {
        form.put(route('organizations.accounts.update', {
            organization: organizationId.value,
            account: currentId.value
        }), opts);
    }
};
</script>

<template>
    <BaseSettingsForm :read-only="readOnly" :form="form" no-title @submit="submit">
        <div class="pt-5">
            <BaseInputLabeled :error="form.errors.name" v-model="form.name"
                              label="Название" :disabled="readOnly"/>
        </div>
        <div class="pt-5">
            <BaseInputLabeled :error="form.errors.payment_account" v-model="form.payment_account"
                              label="Расчетный счет" required :disabled="readOnly"/>
        </div>
        <div class="pt-5">
            <BaseInputLabeled :error="form.errors.correspondent_account" v-model="form.correspondent_account"
                              label="Корреспондентский счет" required :disabled="readOnly"/>
        </div>
        <div class="pt-5">
            <BaseInputLabeled :error="form.errors.bik" v-model="form.bik"
                              label="БИК банка" required :disabled="readOnly"/>
        </div>
    </BaseSettingsForm>
</template>
